
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import TtkList from './TtkList';
 
const CateringTTK = ({ data }) => {
    const checkNAStatus = (num) => {
        const numberString = num?.toString();
        return numberString?.length <= 2 ? " NA" : (
            <span>&nbsp;&#8377;&nbsp; {num}</span>
        )
    }
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Maximum Capacity :</b>&nbsp;<span>{data?.maxCap}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Minimum Capicity :</b>&nbsp;<span>{data?.minCap}</span></p>
                        </div>

                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area Of Working:</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> &nbsp;<b>Starting Veg Price Per Plate :</b>
                                <span>
                                    {checkNAStatus(data?.vegPrice)}
                                </span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> &nbsp;<b>Starting Non-Veg Price Per Plate :</b><span>
                                    {checkNAStatus(data?.nonVegPrice)}
                                </span></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CateringTTK